module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-01-Panel.960ab9f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-01-Panel.jpg
// module id = 945
// module chunks = 37